import noop from 'lodash/noop';
import { fromCallback } from 'xstate';

import {
  AudioFileSystemEvents,
  type AudioFileSystemInput as Input,
} from './audioFileSystem.types';

export const noopAudioFileSystem = fromCallback<AudioFileSystemEvents, Input>(
  ({ input, sendBack, receive }) => {
    const { logger } = input;

    const initializeFileSystem = async () => {
      logger('info', 'Initializing NoopAudioFileSystem actor');
      // Immediately report healthy since this actor is no longer
      // responsible for writing data or managing the file system
      sendBack({
        type: 'fileSystem.ready',
      });
    };

    initializeFileSystem();

    receive((event) => {
      if (event.type === 'fileSystem.close') {
        logger('info', 'Received fileSystem.close event');
      }
    });

    return noop;
  },
);
